import { render, staticRenderFns } from "./QuestionBankManagement.vue?vue&type=template&id=e02afa8c&scoped=true"
import script from "./QuestionBankManagement.vue?vue&type=script&lang=js"
export * from "./QuestionBankManagement.vue?vue&type=script&lang=js"
import style0 from "./QuestionBankManagement.vue?vue&type=style&index=0&id=e02afa8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02afa8c",
  null
  
)

export default component.exports